import { useCallback } from "react";
// import { useWeb3React } from "@web3-react/core";
import { userSmartAccount } from "../../../components/RecoilAtom";
import { useRecoilValue } from "recoil";
import {
  getBalance,
  getLiquidityPool,
  getCrashGameContract,
} from "../../../utils/contractHelpers";
import {
  usdt_token,
  LUCKIFY_CONTRACT_ADDRESS,
  CRASH_GAME_CONTRACT,
} from "../../../utils/Enviroment";
import Web3 from "web3";
import useWeb3 from '../../../hooks/useWeb3';
import { convertFromWei } from "../../../utils/helpers";
import { useEoaAccount } from "../../useEoaAccount";

export const useCheckAllowance = () => {
  const { account } = useEoaAccount();
  const smartAccount = useRecoilValue(userSmartAccount);
  const web3 = useWeb3();
//   const web4 = new Web3(
//     "https://dimensional-serene-wish.base-mainnet.quiknode.pro/384f047fe7195b52a94e84a42dbc1cc3541a48e5/"
//   );
  let contract;

  const checkAllowance = useCallback(
    async ( gameContract) => {
      try {
        contract = await getBalance(usdt_token, web3);
        const allowance = await contract.methods
          .allowance(smartAccount, gameContract)
          .call();
        const formattedAllowance = convertFromWei(
          String(allowance),
          "mwei"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [smartAccount, contract, web3, account]
  );

  const TotalLiquidityYouProvide = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userLiquidity = await contract.methods
          .lpBalances(internalAccount)
          .call();
        const formattedAllowance = convertFromWei(
          String(userLiquidity),
          "mwei"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  const CurrentLiquidityYouProvide = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userLiquidity = await contract.methods
          .lpShares(internalAccount)
          .call();
        const formattedAllowance = convertFromWei(
          String(userLiquidity),
          "mwei"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  const TotalYourReward = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userReward = await contract.methods
          .claimableRewards(internalAccount)
          .call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  const TotalShare = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userReward = await contract.methods.totalShares().call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  const TotalRewards = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userReward = await contract.methods.totalRewards().call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  return {
    TotalRewards,
    checkAllowance,
    TotalLiquidityYouProvide,
    CurrentLiquidityYouProvide,
    TotalYourReward,
    TotalShare,
  };
};
